import formatName from 'I18n/utils/formatName';
import { useQuery } from 'data-fetching-client';
import { FETCH_USER_INFO } from 'flow-doctor-lib/queries/UserQueries';
const useUserName = ({
  userId
}) => {
  const {
    loading: userInfoLoading,
    error: userInfoError,
    data: userInfoData
  } = useQuery(FETCH_USER_INFO, {
    variables: {
      userId
    }
  });
  const userData = userInfoData && userInfoData.userInfo;
  const fullNameData = userData ? formatName({
    firstName: userData.firstName,
    lastName: userData.lastName,
    email: userData.email
  }) : null;
  return {
    data: fullNameData,
    loading: userInfoLoading,
    error: userInfoError
  };
};
export default useUserName;